import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import CrsMain from "../../components/ComponentsCrsSettings/CrsMain";
import SurveysMain from "../../components/ComponentsSurveys/SurveysMain";
import ReportsMain from "../../components/ComponentsReports/ReportsMain";
import IntegrationsMain from "../../components/ComponentsIntegration/IntegrationsMain";
import BusinessProfileMain from "../../components/ComponentsBusinessProfile/BusinessProfileMain";
import MyProfileMain from "../../components/ComponentsMyProfile/MyProfileMain";
import BillingMain from "../../components/ComponentsBilling/BillingMain";
import TeamMain from "../../components/ComponentsTeam/TeamMain";

const TABS = [
  { key: 'businessProfile', label: 'Business Profile' },
  { key: 'myProfile', label: 'My Profile' },
  { key: 'billing', label: 'Billing' },
  { key: 'team', label: 'Team' },
  { key: 'integrations', label: 'Integrations' },
  { key: 'crs', label: 'CRS Settings' },
  { key: 'surveys', label: 'Surveys' },
  { key: 'reports', label: 'Reports' },
];

const AdminPanel = () => {
  const [activePanel, setActivePanel] = useState('businessProfile');
  const [integrationStatus, setIntegrationStatus] = useState({
    slack: false,
    zoom: false,
  });
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Handle Slack and Zoom redirects and query parameters
  useEffect(() => {
    if (location.pathname.includes('/admin-panel/integrations/slack')) {
      const connected = searchParams.get('connected');
      if (connected === "1") {
        setIntegrationStatus((prev) => ({ ...prev, slack: true }));
        setActivePanel('integrations'); // Switch to integrations panel
        navigate('/admin-panel/integrations', { replace: true });
      }
    }

    // Handle Zoom redirect - check for workspaceId parameter which indicates Zoom OAuth return
    if (location.pathname === '/admin-panel' && searchParams.get('workspaceId')) {
      // Zoom has completed OAuth and redirected back
      setIntegrationStatus((prev) => ({ ...prev, zoom: true }));
      setActivePanel('integrations'); // Switch to integrations panel
      // Clean up the URL by removing the workspaceId parameter
      navigate('/admin-panel', { replace: true });
    }
  }, [location, searchParams, navigate]);

  const handleButtonClick = (panelName) => {
    setActivePanel(activePanel === panelName ? null : panelName);
  };

  const panels = {
    businessProfile: <BusinessProfileMain />,
    myProfile: <MyProfileMain />,
    billing: <BillingMain />,
    team: <TeamMain />,
    crs: <CrsMain />,
    surveys: <SurveysMain />,
    reports: <ReportsMain />,
    integrations: <IntegrationsMain integrationStatus={integrationStatus} />,
  };

  return (
    <div className="flex flex-col items-center px-2 sm:px-4">
      <div className="w-full max-w-layout rounded-lg bg-white p-5 shadow-card sm:p-8">
        <h1 className="mb-5 w-full text-left">Admin Panel</h1>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {TABS.map((tab) => {
            const active = activePanel === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => handleButtonClick(tab.key)}
                className={`rounded-xl px-4 py-3 text-center font-ui text-sm font-semibold transition-all
                            ${active
                                ? 'bg-purple-alt text-white shadow-card ring-2 ring-purple ring-offset-2'
                                : 'bg-purple text-white hover:-translate-y-0.5 hover:bg-purple-hover hover:shadow-card'}`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {activePanel && (
        <div className="mt-6 w-full max-w-layout">
          {panels[activePanel]}
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
